/**
 * SPDX-FileCopyrightText: 2022 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */

import { createApp } from 'vue'
import AdminSettings from './views/AdminSettings.vue'

// Styles
import '@nextcloud/dialogs/style.css'

export default createApp(AdminSettings).mount('#notifications-admin-settings')
